import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"


Vue.config.productionTip = false

export const bus = new Vue();



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
